export type ISampleEvent = ReturnType<typeof sampleEventFactory>;

/* @ngInject */
export function sampleEventFactory($translate) {
  return {
    getSampleEvent() {
      return $translate([
        'sample-event-the-venue',
        'sample-event-description',
      ]).then(function(translated) {
        const venueLabel = translated['sample-event-the-venue'];
        const description = translated['sample-event-description'];

        return [
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-12T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'San Francisco, CA',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'San Francisco',
              region: 'CA',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-14T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'Los Angeles, CA',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'Los Angeles',
              region: 'CA',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-16T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'Phoenix, AZ',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'Phoenix',
              region: 'AZ',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-18T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'Austin, TX',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'Austin',
              region: 'TX',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-20T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'New York City, NY',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'New York City',
              region: 'NY',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-22T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'Washington, DC',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'Washington',
              region: 'DC',
              country: 'United States',
            },
          },
          {
            id: 1111,
            title: 'Sample Concert',
            datetime: '2023-11-25T19:00:00',
            formatted_datetime: 'Saturday, August 15, 2015 at 7:00PM',
            formatted_location: 'Boston, MA',
            ticket_url: '',
            ticket_type: 'Tickets',
            ticket_status: 'available',
            on_sale_datetime: '2015-06-26T10:00:00',
            facebook_rsvp_url: '',
            description,
            artists: [
              {
                name: 'Artist Name',
              },
            ],
            venue: {
              name: venueLabel,
              city: 'Boston',
              region: 'MA',
              country: 'United States',
            },
          },
        ];
      });
    },
  };
}
